// @flow
import React from 'react'
import { Link } from 'gatsby'

type Props = {
  title: string,
  path: string,
  artist: string,
  number: number,
  medium?: boolean,
  small?: boolean,
  type: string,
}

const GridElement = ({
  title,
  path,
  artist,
  number,
  type,
  medium = false,
  small = false,
}: Props) => (
  <div>
    <Link to={path} title={title} className="linkRow">
      <h3>#{number}</h3>
      {/* eslint-disable-next-line import/no-dynamic-require, global-require */}
      <img src={require(`../images/covers/${type}-${number}.jpg`)} alt={title} />
      <h2>{artist}</h2>
    </Link>
    <style jsx>{`
      div {
        flex: 1 1 ${medium ? '30%' : small ? '48%' : '23%'};
        margin: 1%;
        opacity: ${small ? '1;' : '0.6;'};
        transition: all 250ms ease-out;
        ${small || medium ? '' : 'max-width: 300px;'}
      }

      div:hover {
        ${small ? '' : 'transform: scale(1.05);'}
        opacity: 1;
      }

      img {
        margin: 0;
      }

      h2,
      h3 {
        margin: 10px;
        text-align: center;
      }

      :global(.linkRow) {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-decoration: none;
      }

      :global(.linkRow:active),
      :global(.linkRow:visited) {
        text-decoration: none;
      }
    `}</style>
  </div>
)

export default GridElement
